<template>
  <div class="align-horizontal paragraph_row paragraph_top_border">
    <div class="paragraph_content">{{item.stdrYear}}. 01</div>
    <div class="paragraph_line"></div>
    <div class="paragraph_content">{{util.formatNumber(item.prvuseAr)}}</div>
    <div class="paragraph_line"></div>
    <div class="paragraph_content">{{util.formatNumber(item.pblntfPc)}}</div>
  </div>
</template>

<script>
import moment from "moment";
import Utils from "../../config/utils";
const u = require('util');


export default {
  name: "InquiryItem2",
  props:['item'],
  components:{
    
  },
  inject: ["eventBus"],
  data() {
    return {
      util: Utils,
      self: this,
      u:u,
    }
  },
  computed:{
    
  },
  methods:{
  },
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/vars";

.paragraph {
  border: 1px solid $c_cacbcd;
}
.paragraph_row {
  height: 30px;
}
.paragraph_header {
  background-color: #e8f1f4;
}
.paragraph_top_border {
  border-top: 1px solid $c_cacbcd;
}
.paragraph_line {
  width:1px;
  height:30px;
  background-color:$c_cacbcd;
}
.paragraph_title {
  flex:1;
  font-size: $fs_14;
  font-family: $korean_gd_14_r;
  font-weight: bold;
  color: $black;
  text-align: center;
}
.paragraph_content {
  flex:1;
  font-size: $fs_15;
  font-family: $korean_gd_14_r;
  color: $black;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/controls/InquiryItem2.vue